import { call, select } from 'redux-saga/effects';
import { isPixelEnabled, makeSelectIsPixelEnabled } from '@dbh/site-customizations-redux';
import { makeSelectIsFirstPageAfterSsr, makeSelectLocationHref, makeSelectCountry } from '@dbh/routing-redux';
import { logTracking } from '@dbh/tracking-loggers';
import _memoize from 'lodash/memoize';
import { makeSelectCurrencyData } from '@dbh/countries-redux';
import throwInServerSideRendering from '@dbh/throw-in-server-side-rendering';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import '@dbh/booking-types';
import { PIXELS } from '@dbh/daybreak-hero-redux';
import 'prop-types';

/**
 * Fires the `Bing` page view event. The `Bing` script was loaded in
 * `@dbh/browser-bing`.
 * @yields {Object?} .
 */function*fireBingPixelPageView(){const a=yield call(isPixelEnabled,"bing");if(a){const a=yield select(makeSelectIsFirstPageAfterSsr());// The tracking of the landing page is handled by the inline script, which is
// executed before all the rest of the code is loaded.
// @see `injectBingScript`.
if(!a){const a=yield select(makeSelectLocationHref());// The following line shouldn't be necessary, we load the `Bing` script
// before `React`, but just in case.
window.uetq=window.uetq||[],window.uetq.push("event","page_view",{page_path:a}),logTracking("[bing][page_view]",a);}}}

/**
 * Fires `bing` conversion event.
 * @param {Immutable.Map} booking The booking `API` response.
 */const fireBingConversion=_memoize(withConformsTo("fireBingConversion",[],function*(a){if(throwInServerSideRendering("fireBingConversion"),!(yield select(makeSelectIsPixelEnabled(PIXELS.BING))))return;const b=yield select(makeSelectCountry()),c=a.getIn(["pricesTotal","discounted"])||a.getIn(["pricesTotal","actual"]),d=yield select(makeSelectCurrencyData()),e={event_category:"Hotel Booking",event_label:"Booking "+b,revenue_value:c,currency:null==d?void 0:d.currencyCode};logTracking("[bing][purchase]",e),window.uetq.push("event","purchase",e);}),a=>a&&a.get?a.get("idBooking"):"");var fireBingConversion$1 = fireBingConversion;

/**
 * Fires the `bing` consent `update` event.
 * @param {boolean} isConsentGranted .
 * @return {boolean} .
 */const updateBingConsent=withConformsTo("updateBingConsent",[],async a=>{const b={ad_storage:a?"granted":"denied"};window.uetq.push("consent","update",b),logTracking("[bing][consent][update]",b);});var updateBingConsent$1 = updateBingConsent;

export { fireBingConversion$1 as fireBingConversion, fireBingPixelPageView, updateBingConsent$1 as updateBingConsent };
